import { render, staticRenderFns } from "./EditInspectionFormComponent.vue?vue&type=template&id=0b7742ca"
import script from "./EditInspectionFormComponent.vue?vue&type=script&lang=js"
export * from "./EditInspectionFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports